(function () {
  function syncCheckoutTotal() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var source = drawer.querySelector('[data-cart-total]');
    var targets = drawer.querySelectorAll('[data-cart-checkout-total]');
    if (!source || !targets.length) return;

    var value = source.textContent.trim();
    targets.forEach(function (target) {
      if (target.textContent.trim() !== value) {
        target.textContent = value;
      }
    });
  }

  function connect() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || drawer.__upgradeObserver) {
      syncCheckoutTotal();
      return;
    }

    drawer.__upgradeObserver = new MutationObserver(syncCheckoutTotal);
    drawer.__upgradeObserver.observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true
    });

    syncCheckoutTotal();
  }

  document.addEventListener('DOMContentLoaded', connect);
  document.addEventListener('theme:cart:change', function () {
    window.setTimeout(syncCheckoutTotal, 0);
  });
  document.addEventListener('shopify:section:load', connect);

  if (document.readyState !== 'loading') {
    connect();
  }
})();
